/* PEACOCK 2026 — capa de experiencia (vanilla, transform-only, 60fps) */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal + cortinas de imagen al entrar en viewport */
  function initReveal() {
    var els = document.querySelectorAll('.pk-reveal, .pk-curtain');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* Titular del hero: entra palabra por palabra */
  function initSplit() {
    document.querySelectorAll('[data-pk-split]').forEach(function (el) {
      if (el.getAttribute('data-pk-split-done')) return;
      el.setAttribute('data-pk-split-done', '1');
      if (reduced) return;

      function wrapWords(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) {
                frag.appendChild(document.createTextNode(part));
              } else {
                var w = document.createElement('span');
                w.className = 'pk-w';
                var inner = document.createElement('span');
                inner.className = 'pk-w__i';
                inner.textContent = part;
                w.appendChild(inner);
                frag.appendChild(w);
              }
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            wrapWords(child);
          }
        });
      }

      wrapWords(el);
      el.querySelectorAll('.pk-w__i').forEach(function (s, i) {
        s.style.transitionDelay = (0.09 + i * 0.055).toFixed(3) + 's';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('pk-split-in');
        });
      });
    });
  }

  /* Parallax sutil en imágenes (contenedor con data-pk-parallax) */
  function initParallax() {
    if (reduced) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-pk-parallax]'));
    if (!els.length) return;

    var items = els.map(function (el) {
      var target = el.querySelector('img') || el.firstElementChild;
      if (target) {
        target.style.transition = 'none';
        target.style.willChange = 'transform';
      }
      return { el: el, target: target, speed: parseFloat(el.getAttribute('data-pk-parallax')) || 0.08 };
    });

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        if (!it.target) return;
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        it.target.style.transform = 'translateY(' + (-progress * it.speed * 100).toFixed(2) + '%) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* Contadores: los stats cuentan hasta su valor al entrar en viewport */
  function initCounters() {
    var els = document.querySelectorAll('.pk-promesa__stat');
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var text = el.textContent.trim();
      var m = text.match(/^(\D*)([\d.]+)(\D*)$/);
      if (!m) return;
      var target = parseInt(m[2].replace(/\./g, ''), 10);
      if (!target || target > 999999) return;
      var prefix = m[1], suffix = m[3];
      var start = null, dur = 1100;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = Math.round(target * eased);
        el.textContent = prefix + val.toLocaleString('es-CL') + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Botones magnéticos (solo puntero fino) */
  function initMagnetic() {
    if (reduced || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.pk-hero__ctas .button--primary, .pk-offer .button').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 7).toFixed(1) + 'px, ' + (y * 5).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* Historia scrollytelling: capítulos que se viven scrolleando */
  function initHistoria() {
    var root = document.querySelector('[data-pk-historia]');
    if (!root) return;
    if (reduced) return;

    root.classList.add('pk-historia--js');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('.pk-historia__chapter'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.pk-historia__dot'));
    var track = root.querySelector('.pk-historia__track');
    if (chapters.length < 2 || !track) return;

    var current = 0;
    var ticking = false;

    function setActive(i) {
      if (i === current) return;
      chapters[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = i;
      chapters[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function update() {
      var r = track.getBoundingClientRect();
      var scrollable = r.height - window.innerHeight;
      if (scrollable <= 0) { ticking = false; return; }
      var progress = Math.min(Math.max(-r.top / scrollable, 0), 0.9999);
      setActive(Math.floor(progress * chapters.length));
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* Sticky add-to-cart (mobile) */
  function initStickyAtc() {
    var bar = document.querySelector('.pk-sticky-atc');
    if (!bar) return;
    var target = document.querySelector('.product-form__submit');
    if (!target || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(target);

    var btn = bar.querySelector('[data-pk-sticky-submit]');
    if (btn) {
      btn.addEventListener('click', function () {
        target.click();
      });
    }
  }

  /* Add-on (estuche): agrega al carrito vía AJAX y refresca el drawer */
  function initAddons() {
    document.querySelectorAll('[data-pk-addon]').forEach(function (btn) {
      if (btn.getAttribute('data-pk-bound')) return;
      btn.setAttribute('data-pk-bound', '1');
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-pk-addon');
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = btn.getAttribute('data-pk-adding') || '…';

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var sectionsToBundle = [];
        if (cart && typeof cart.getSectionsToRender === 'function') {
          cart.getSectionsToRender().forEach(function (s) { sectionsToBundle.push(s.id); });
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (cart && typeof cart.renderContents === 'function' && !data.status) {
              cart.renderContents(data);
            } else if (!data.status) {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
            btn.textContent = btn.getAttribute('data-pk-added') || original;
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 2500);
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
          });
      });
    });
  }

  function init() {
    initReveal();
    initSplit();
    initParallax();
    initCounters();
    initMagnetic();
    initHistoria();
    initStickyAtc();
    initAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:refresh', initAddons);
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initSplit();
    initHistoria();
    initAddons();
  });
})();
